export default __webpack_public_path__ + "static/media/circle.035fecd1.png";